module.exports = __webpack_public_path__ + "static/img/3.e666b28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/eng/3.png
// module id = WJuM
// module chunks = 0